import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import config from './config';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <GoogleReCaptchaProvider reCaptchaKey={config.siteKey}>
          <App />
        </GoogleReCaptchaProvider>
      </BrowserRouter>
    </Provider>
  // </React.StrictMode>
);
